import { z } from "zod";
export * from "./advertising.js";
export const ChannelDirectionSchema = z.enum(["up", "down"]);
export const ClientCapabilitiesSchema = z.object({
    video_types: z.array(z.string()).default([]),
    seek_required: z.boolean().default(false),
    touch_capable: z.boolean().optional(),
    viewport_width: z.number().int().positive().optional(),
    viewport_height: z.number().int().positive().optional(),
    autoplay_muted_required: z.boolean().optional()
});
export const RANDO_CHANNEL = 69;
export const RANDO_STATION = { id: "00000000-0000-4000-8000-000000000069", channel: RANDO_CHANNEL, call_sign: "RANDO", name: "Rando", identity: "A random discovery, just for you" };
export const NextChannelRequestSchema = z.object({
    session_id: z.string().uuid(),
    viewer_id: z.string().uuid(),
    current_item_id: z.string().uuid().nullable().optional(),
    current_channel: z.number().int().min(2).max(69),
    direction: ChannelDirectionSchema,
    mode: z.literal("rando").optional(),
    replay_item_id: z.string().uuid().optional(),
    replay_offset_seconds: z.number().finite().min(0).optional(),
    recent_item_ids: z.array(z.string().uuid()).max(24).default([]),
    client_capabilities: ClientCapabilitiesSchema
});
export const PlaybackEventSchema = z.object({
    session_id: z.string().uuid(),
    viewer_id: z.string().uuid(),
    media_item_id: z.string().uuid(),
    channel_number: z.number().int().min(2).max(69),
    event: z.enum(["start", "stop", "channel_change", "natural_end", "playback_error", "page_hidden", "session_end"]),
    start_offset_seconds: z.number().min(0).optional(),
    watch_seconds: z.number().min(0).optional(),
    completion_ratio: z.number().min(0).max(1).optional(),
    client_context: z.record(z.unknown()).optional()
});
export const PresenceRequestSchema = z.object({
    session_id: z.string().uuid(),
    viewer_id: z.string().uuid(),
    sequence: z.number().int().min(1).max(Number.MAX_SAFE_INTEGER),
    watching: z.boolean(),
    channel: z.number().int().min(2).max(69).nullable().optional()
});
export const PresenceResponseSchema = z.object({
    watching_now: z.number().int().nonnegative(),
    station_watching_now: z.number().int().nonnegative().nullable().optional(),
    channel: z.number().int().min(2).max(69).nullable().optional(),
    server_time: z.string().datetime()
});
export const FeedbackSchema = z.object({
    session_id: z.string().uuid(),
    item_id: z.string().uuid(),
    signal: z.enum(["MORE_LIKE_THIS", "LESS_LIKE_THIS"])
});
export const ItemFaceSchema = z.object({
    id: z.string().uuid(),
    title: z.string(),
    subtitle: z.string().nullable(),
    genre: z.string().nullable(),
    program_type: z.string().nullable(),
    year: z.number().int().nullable(),
    era: z.string().nullable(),
    network: z.string().nullable(),
    station: z.string().nullable()
});
export const ChatMessageSchema = z.object({
    id: z.string().uuid(),
    author: z.string(),
    text: z.string().max(280),
    sent_at: z.string().datetime()
});
export const ChatResponseSchema = z.object({
    channel: z.number().int().min(2).max(69),
    author: z.string(),
    messages: z.array(ChatMessageSchema).max(50)
});
export const ChatPostSchema = z.object({
    id: z.string().uuid(),
    text: z.string().trim().min(1).max(280).refine((text) => !/[\u0000-\u001f\u007f-\u009f\u202a-\u202e\u2066-\u2069]/u.test(text), "Use a single line of plain text")
});
/** Reserved public-camera channels, shared by the viewer and station chat. */
export const WEBCAM_CHANNELS = [60, 61, 62, 63, 64];
export const GUIDE_CHANNEL = 3;
export * from "./display-ads.js";
export * from "./usage.js";
export * from "./classification.js";
